(() => {
 const mq=window.matchMedia('(max-width: 749px)');
 const root=document.documentElement;
 let api=null, lastTrigger=null;
 function sync(){if(!api)return;if(mq.matches&&!root.classList.contains('mt-mobile-chat-open'))api.hide();else api.show();}
 function ready(){
  if(api===window.tidioChatApi)return;
  api=window.tidioChatApi;if(!api)return;
  api.on('close',()=>{root.classList.remove('mt-mobile-chat-open');sync();if(lastTrigger&&mq.matches)lastTrigger.focus();});
  sync();
 }
 document.addEventListener('tidioChat-ready',ready);
 if(window.tidioChatApi){window.tidioChatApi.on('ready',ready);ready();}
 mq.addEventListener('change',sync);
 document.addEventListener('click',e=>{
  const link=e.target.closest('[data-mt-open-chat]');
  if(!link||!mq.matches)return;
  if(!api||typeof api.open!=='function')return;
  e.preventDefault();lastTrigger=link;root.classList.add('mt-mobile-chat-open');api.show();api.open();
 });
})();
